/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Differences_WaitingInputs */

const en_queue_differences_waiting = /** @type {(inputs: Queue_Differences_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse counts to apply`)
};

/**
* | output |
* | --- |
* | "Warehouse counts to apply" |
*
* @param {Queue_Differences_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_differences_waiting = /** @type {((inputs?: Queue_Differences_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Differences_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_differences_waiting(inputs)
});